import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { parseQueryString } from "utils";

import { mfaCallbackRequest } from "services/identity";

import ContentWrapper from "components/ContentWrapper";
import Spinner from "components/Spinner";
import ROUTES from "navigation/routes";

const TwoFactorAuthentication = () => {
  // This page is shown after user completes first step of authentication and is responsible for calling the MFA callback endpoint, which will validate the MFA code and redirect the user to the appropriate page.
  useEffect(() => {
    const { code, state } = parseQueryString<{ code: string; state: string }>();
    if (code && state) {
      try {
        mfaCallbackRequest({ code, state });
      } catch (error) {
        window.location.assign(ROUTES.LOGIN);
      }
    } else {
      window.location.assign(ROUTES.LOGIN);
    }
  }, []);

  return (
    <ContentWrapper alignCenter>
      <Spinner />
    </ContentWrapper>
  );
};

export default withRouter(TwoFactorAuthentication);
